import Vue from 'vue'
import VueRouter from 'vue-router';
import { ROUTER_LOGIN_SSO, ROUTER_NAME_HOME, ROUTER_ADMIN, ROUTER_NAME_404, ROUTER_NAME_LOGIN, routers } from './router';
import UserPersistence from "../persistence/UserPersistence";
import { VUE_ROUTER_MODE } from "../../config/myConfig";
import BrowserUtils from "../libs/utils/BrowserUtils";
import RouterUtils from "../libs/utils/RouterUtils";
import { ALONE_APP_MODE, EXIT_URL, SERVICE_TYPE as SERVICE, ENV } from "../config/app";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { MSG_MODES, MSG_TYPES, setMessage } from "../libs/message";

/**
 * 重写路由的push方法
 * 为了解决这个报错Navigating to current location (XXX) is not allowed
 * 出现错误原因是已经在某个路由上了，再次通过push方法进入此路由
 */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return routerPush.call(this, location, onResolve, onReject);
  return routerPush.call(this, location).catch(error => error)
};
const routerReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return routerReplace.call(this, location, onResolve, onReject);
  return routerReplace.call(this, location).catch(error => error)
};

Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
  mode: VUE_ROUTER_MODE,
  routes: routers
};

export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {

  if (ENV.NODE_ENV !== 'development') {
    var versionScript = document.createElement("script");
    versionScript.src = location.origin + '/chen.js?v=' + new Date().getTime();
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(versionScript, s);

    window.getVersion = version => {
      if (localStorage.frontendVersion && version !== localStorage.frontendVersion) {
        setMessage({
          type: MSG_TYPES.WARNING,
          mode: MSG_MODES.MESSAGE_BOX,
          message: '系统已更新！请刷新后重试',
          title: "提示",
          onOk: () => window.location.reload(true),
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
        });
        localStorage.frontendVersion = version; // 保存 以便下次使用判断
        return
      }

      localStorage.frontendVersion = version; // 保存 以便下次使用判断
    };
  }

  const menu = UserPersistence.getBaseInfo() && UserPersistence.getBaseInfo().menuList ? UserPersistence.getBaseInfo().menuList : [];
  const menuList = [
    ...menu,
    { routeUrl: ROUTER_NAME_LOGIN },
    { routeUrl: ROUTER_LOGIN_SSO },
    { routeUrl: ROUTER_ADMIN },
    { routeUrl: ROUTER_NAME_HOME },
    { routeUrl: ROUTER_NAME_404 },
    // { routeUrl: "statistic-analysis-land" },
    // { routeUrl: "document-code" },
    // { routeUrl: "administrative-region" },
    // { routeUrl: "subject-message" },
    // { routeUrl: "tax-classification" },
    // { routeUrl: "account-management" },
    // { routeUrl: "deprtment-manage" },
    // { routeUrl: "function-module" },
    // { routeUrl: "supplier-manage" },
    // { routeUrl: "employee-management" },
    // { routeUrl: "client-manage" },
    // { routeUrl: 'business-classification' },
    // { routeUrl: 'invoices-coderule' },
    // { routeUrl: "warehouse-manage" },
    // { routeUrl: "bank-management" },
    // { routeUrl: "zt-configuration" },
    // { routeUrl: "acc-management" },
    // { routeUrl: "assets-class" },
    // { routeUrl: 'project-management' },
    // { routeUrl: 'inventory-management' },
    // { routeUrl: "measure-unit" },
    // { routeUrl: "expense-reimbursement" },
  
    // { routeUrl: "fee-ticket" },
    // { routeUrl: "electronic-document" },
    // { routeUrl: "storge-space" },
    { routeUrl: "reimbursement-task" },
    { routeUrl: "billing-management" },
    { routeUrl: "vendor-billing" },
    { routeUrl: "loan-billing" },
    { routeUrl: "billing-task" },
    { routeUrl: "expenses-billing-management" },
    { routeUrl: "personal-borrowing-management" },
    { routeUrl: "personalize-setting" },
    { routeUrl: "invoices-coding" },
    { routeUrl: "settlement-task" },
    { routeUrl: "settlement-loan" },
    { routeUrl: "settlement-document" },
    { routeUrl: "account-general-ledger" },
    { routeUrl: "account-sub-ledger" },
    { routeUrl: "chronological-account" },
    { routeUrl: "account-balance-table" },
    { routeUrl: "currency-balance-table" },
    { routeUrl: "loan-management" },
    { routeUrl: "purchase-account-manage" },
    { routeUrl: 'pay-account-manage' },
    { routeUrl: 'supplier-handle-search' },
    { routeUrl: "sale-reimbursement-manage" },
    { routeUrl: "red-sales-reimbursement" },
    { routeUrl: "sale-receipt-manage" },
    { routeUrl: "red-sale-receipt-manage" },
    { routeUrl: "sale-customer-query" },
    { routeUrl: "sale-collection" },
    { routeUrl: "red-sale-collection" },
    // { routeUrl: "year-statement" },
    // { routeUrl: "month-statement" },
    // { routeUrl: "quaret-statement" },
    { routeUrl: "bill-invoicing" },
    { routeUrl: "invoice-registration" },
    { routeUrl: "tax-server" },
    { routeUrl: "billing-outlet" },
    { routeUrl: "basic-settings" },
    { routeUrl: "staff-info" },
    { routeUrl: "salary-init" },
    { routeUrl: "basic-info-collect" },
    { routeUrl: "staff-specific-info-collect" },
    { routeUrl: "job-salary" },
    { routeUrl: "labor-remuneration" },
    // { routeUrl: "wages" },
    { routeUrl: 'mine-repay-ment' },
    { routeUrl: 'repay-ment' },
    { routeUrl: 'settlement-repay-ment' }
  ];
  BrowserUtils.setTitle(to.meta.title);
  NProgress.start();
  const curRouterObj = RouterUtils.getRouterObjByName(menuList, to.name);

  // if (!curRouterObj) {//如果这个路由没有找到
  //   next({
  //     replace: true,
  //     name: ROUTER_NAME_404
  //   });
  // } else {
  if (!UserPersistence.getToken() && to.name !== ROUTER_NAME_LOGIN && to.name !== ROUTER_NAME_404 && to.name !== ROUTER_LOGIN_SSO) { // 当前没有登录，且前往的页面不是主页或登录页或404
    //跳转到主页面
    next({
      name: ROUTER_NAME_LOGIN,
      // params: { servers: UserPersistence.getServiceType() }
    });
    if (ENV.NODE_ENV !== 'development') {
      window.location.href = EXIT_URL();
    } else {//localhost
      next({
        name: ROUTER_NAME_LOGIN,
      });
    }
    NProgress.done();
  } else if (UserPersistence.getToken() && (to.name === ROUTER_NAME_LOGIN)) { // 当前已经登录，且前往的是登录页
    BrowserUtils.setTitle(null);
    next({
      name: ROUTER_NAME_HOME,
    });
  } else {
    next()
    }
  // }

});

router.afterEach((to) => {
  NProgress.done();
  // Util.openNewPage(router.app, to.name, to.params, to.query);
  window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// ./src/router/index.js